<script setup>
import { computed } from 'vue';
import { CORES_STATUS_SOLICITACAO, ICONES_STATUS_SOLICITACAO } from '@/commons/projetos';

const props = defineProps({
    valor: String,
});

const cor = computed(() => CORES_STATUS_SOLICITACAO[props.valor] ?? 'cinza');
const icone = computed(() => ICONES_STATUS_SOLICITACAO[props.valor]);
</script>

<template>
    <TagBase :valor="valor" :cor="cor" :icone="icone" />
</template>
